<template>
  <div class="scroll-vertical full-height big-spacer related-processes">
    <content-nav-bar v-if="nameTree.length > 0" class="process-tree">
      <svgicon name="tree" height="20" width="20" class="level-item"></svgicon>
        <div
          v-for="name in nameTree"
          :key="name"
          class="level-item process-tree-tag">
          <div class="tag">{{ name }}</div>
        </div>
      <!-- <p class="level-item tree">{{ nameTree.join('  →  ') }}</p> -->
    </content-nav-bar>
    <div v-for="process in sortedProcesses" :key="process.pid" class="spacer">
      <content-nav-bar class="process-title">
        <svgicon name="process_circle" height="20" width="20" class="level-item"></svgicon>
        <p class="is-size-4 level-item">{{ process.name }} ({{ process.pid }})</p>
      </content-nav-bar>
      <alert-log-process :process="process" :related="related"></alert-log-process>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import ContentNavBar from '@/components/ContentNavBar.vue';
import AlertLogProcess from '@/components/alertlogs/AlertLogProcess.vue';

export default {
  name: 'AlertRelatedProcesses',
  components: {
    AlertLogProcess,
    ContentNavBar,
  },
  props: {
    processes: {
      type: Array,
      required: true,
    },
    related: {
      type: Object,
      required: true,
    },
    primary: {
      type: Number,
      default: null,
    },
  },
  computed: {
    sortedProcesses() {
      return _.orderBy(this.processes, 'pid', 'desc');
    },
    nameTree() {
      const procs = [];
      let startPid = this.primary;
      // If a pid is passed in, use it as the primary
      if (!startPid) {
        // else get the largest pid
        if (this.sortedProcesses.length > 0) {
          startPid = this.sortedProcesses[0].pid;
        }
      }
      // If we have a startPid, build the tree until resolving fails
      if (startPid) {
        let currentPid = startPid;
        let index = _.findIndex(this.processes, { pid: currentPid });
        while (index >= 0) {
          procs.push(`${this.processes[index].name} (${this.processes[index].pid})`);
          currentPid = this.processes[index].ppid;
          index = _.findIndex(this.processes, { pid: currentPid });
        }
      }

      if (procs.length > 0) {
        procs.push('launchd (1)');
        procs.push('kernel_task (0)');
      }

      return procs;
    },
  },
};
</script>

<style lang="scss" scoped>

.process-tree-tag::before {
  content: "←";
}

.process-tree-tag:nth-child(2)::before {
  content: "";
}

.spacer {
  border-bottom: .75rem solid $main-background;
}

.big-spacer {
  padding-bottom: 8rem;
}

.full-height {
  height: 100%;
}

.tree {
  flex-shrink: 1;
  word-break: break-all;
  font-size: .9rem;
}

.process-tree {
  background-color: $tile-info-highlight;
  color: whitesmoke;
  font-weight: 500;
}

.process-title {
  border-top: 2px solid $form-subitem;
}
</style>
